import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';

export interface CampPatientnotesParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface CampPatientnotes {

    regId?:any;
    isPatientRegistered:string;
    firstName:string;
   lastName?:string;
   dOB?:any;
   campId?:string;
   age?:number;
   gender?:string;
   maritalStatus:string;
   city?:string;
   district?:String;
   state?:string;
   country?:string;
   pincode?:string;
   address1?:string;
  address2?:string; 
  mobile?:string;
  alternateNo?:string;
  aaadhar?:string;
  doorNo?:string;
  bloodGroup?:string;
  email?:string;
    pancard?:string;
   nhid?:string;
    insuranceName?:string;
    insuranceDetails?:string;  
    campPatientEhrNotes?:any;
    physicianId?:any;
    createdDate:any
    createdBy: any,
    updatedBy: any,
    updatedDate: any,
    branchId:any;
    tenantId:any;
    parameters?: CampPatientnotesParameter[];
    links?: any;
}

export abstract class CampPatientnotesData {
    abstract list(url: string): Observable<CampPatientnotes[]>;
    abstract create(url: string, data: any): Observable<any[]>;
    abstract searchList(url: string,data:any): Observable<any>;
    abstract update(url: string, data: CampPatientnotes): Observable<CampPatientnotes>;
    abstract delete(url: string): Observable<any>;
}